import { Injectable, NgModule } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { MenuModel } from 'app/models/menu.model';
import { HeroIconDirective } from './hero-icon.directive';
import { CommonModule } from '@angular/common';

@Injectable({
  providedIn: 'root'
})

export class SharedService {
  private commandNameSource = new BehaviorSubject<string>(null);
  private filterSource = new BehaviorSubject<string>(null);
  private scopeSource = new BehaviorSubject<string>(null);
  private sortSource = new BehaviorSubject<string>(null);
  private viewCodeSource = new BehaviorSubject<string>(null);
  private linkSource = new BehaviorSubject<string>(null);
  private menuDataSource = new BehaviorSubject<MenuModel[]>(null);

  commandName$ = this.commandNameSource.asObservable();
  filter$ = this.filterSource.asObservable();
  scope$ = this.scopeSource.asObservable();
  sort$ = this.sortSource.asObservable();
  viewCode$ = this.viewCodeSource.asObservable();
  menuData$ = this.menuDataSource.asObservable();
  Link$ = this.linkSource.asObservable();

  private menuData: MenuModel[] = [];

  updateLink(value: string) {
    console.log('Updating Link:', value);
    this.linkSource.next(value);
  }

  updateCommandName(value: string) {
    console.log('Updating commandName:', value);
    this.commandNameSource.next(value);
  }

  updateFilter(value: string) {
    console.log('Updating filter:', value);
    this.filterSource.next(value);
  }

  updateScope(value: string) {
    console.log('Updating scope:', value);
    this.scopeSource.next(value);
  }

  updateSort(value: string) {
    console.log('Updating sort:', value);
    this.sortSource.next(value);
  }

  updateViewCode(value: string) {
    console.log('Updating viewCode:', value);
    this.viewCodeSource.next(value);
  }

  // Metodo per cancellare i parametri
  resetParams() {
    console.log('Resetting parameters');
    this.commandNameSource.next(null);
    this.filterSource.next(null);
    this.scopeSource.next(null);
    this.sortSource.next(null);
    this.viewCodeSource.next(null);
  }

  updateMenuData(menuData: MenuModel[]): void {
    console.log('Updating menuData:', menuData);
    console.log('with ', 
    this.commandName$,
    this.filter$,
    this.scope$,
    this.sort$,
    this.viewCode$
    );
    this.menuDataSource.next(menuData);
    return;
  }

  getMenuByLink(link: string): Observable<MenuModel> {
    console.log('Getting menu by link:', link);
    const menu = this.menuData.find(m => m.link === link);
    if (menu) {
      return of(menu);
    } else {
      console.log('Menu not found for link:', link);
      // Ritorna un observable che emette null nel caso in cui il menu non sia trovato
      console.log('menu non caricato:', menu);
      return of(menu);
    }
  }
  
}
